import { IconButton, Link, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { BsArrowReturnRight } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'

export default function Header(props: {
	title: string
	icon: JSX.Element
	userGroups?: any
	project?: any
}) {
	const navigate = useNavigate()

	return (
		<Box
			display="flex"
			flexDirection="column"
			alignItems="flex-start"
			sx={{
				width: '100%',
				paddingX: '20px',
			}}
		>
			<Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
				{props.icon}
				<Typography
					sx={{
						marginLeft: '30px',
					}}
					variant="config_header"
				>
					{props.title}
				</Typography>
			</Box>

			{props.userGroups?.length > 0 || props.userGroups !== undefined ? (
				<Box
					sx={{
						display: 'flex',
						justifyItems: 'center',
            alignItems: 'center'
					}}
				>
					<BsArrowReturnRight style={{ fontSize: '25px', color: '#707070', marginLeft: '30px' }} />
					<Box
						onClick={() => {
							navigate('/configurations/users_config/user_groups/projects')
						}}
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							margin: '0 5px 0 5px',
						}}
					>
						<Link variant="h4">&nbsp;{'All Project'}&nbsp; </Link>
					</Box>
					<Typography>/</Typography>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							margin: '0 5px 0 5px',
						}}
					>
						<Link variant="h4">{props.project?.display_name} </Link>
					</Box>
				</Box>
			) : null}
		</Box>
	)
}
